/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GenresEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    BreadcrumbService: JS5Object,
    GenresService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {};

    const getData = () => {
        this.loadingIndicator.show = true;
        GenresService.getGenre($routeParams.id).then((genre: JS5Object) => {
            GenresService.originalEditData = _.cloneDeep(genre);
            this.editData = genre;
            this.gridOptions.data = _.toArray(genre.aliases);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    const saveHandler = () => {
        _.set(this.editData, 'aliases', _.toArray(this.gridOptions.data));
        _.forEach(_.get(this.editData, 'aliases'), (alias: JS5Object) => {
            _.unset(alias, 'edited');
        });
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewGenre();
        } else {
            updateGenre();
        }
    };

    const updateGenre = () => {
        GenresService.updateGenre(this.editData).then((genre: JS5Object) => {
            GenresService.originalEditData = _.cloneDeep(genre);
            this.editData = genre;
            this.editorForm.$setPristine();
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveNewGenre = () => {
        GenresService.createGenre(this.editData).then((genre: JS5Object) => {
            $route.updateParams({id: genre.id});
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const addAliasHandler = (selectedPartners: Array<JS5Object>) => {
        let originalGridDataSize = _.size(this.gridOptions.data);
        let selectedAliases = new Array<JS5Object>();
        selectedPartners.forEach((selectedPartner: JS5Object) => {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });

        this.gridOptions.data = _.unionBy(_.toArray(this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(this.gridOptions.data) > originalGridDataSize) {
            this.editorForm.$setDirty();
        }

        this.loadingIndicator.show = false;
    };

    this.removeAlias = () => {
        const selectedAliases = this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {

            this.gridOptions.data = _.differenceBy(this.gridOptions.data, selectedAliases, 'partner.id');
            this.editorForm.$setDirty();
        });
    };

    this.addAlias = () => {
        ModalService.showAliasesModal(addAliasHandler);
    };

    const columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];

    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.edit.on.afterCellEdit(
                null,
                (rowEntity: JS5Object, colDef: JS5Object, newValue: any, oldValue: any) => {
                    if (newValue !== oldValue) {
                        _.set(rowEntity, 'edited', true);
                    }
                });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && !!_.get(this.editData, 'name')
                && _.every(this.gridOptions.data, (gridItem: JS5Object) => {
                    return _.size(gridItem.alias);
                }),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(GenresService.originalEditData);
                this.gridOptions.data = _.get(this.editData, 'aliases');
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/properties/search`).search({tab: 'Genres'})
        }
    ];

    this.$onInit = () => {
        SidebarService.editService = GenresService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Genre',
                        location: '/system/properties/search',
                        params: {
                            tab: 'Genres'
                        }
                    });
                }
                getData();
            } else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Genre',
                    location: '/system/properties/search',
                    params: {
                        tab: 'Genres'
                    }
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        GenresService.originalEditData = null;
        GenresService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            GenresService.editorForm = this.editorForm;
            BreadcrumbService.editService = GenresService;
        });
    };
}


angular.module('prism-ui.genres').component('genresEditView', {
    templateUrl: 'system/genres/editor/genres-edit-view-template.html',
    controller: GenresEditViewController,
    bindings: {
    }
});
